/* eslint react-hooks/exhaustive-deps: "warn" */

import { useRef } from 'react';

import { useIntersection } from 'hooks/useIntersection';

import styles from './ConcentrationGraph.module.scss';

import { CONCENTRATION_GRAPH_SVG } from './ConcentrationGraph.svg';

export const ConcentrationGraph = () => {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useIntersection(ref, { threshold: 0.3 });

  return (
    <div ref={ref} className={styles.card}>
      <div className={styles.header}>
        <span className={styles.title}>Corporate linkage · Supplier base</span>
        <span className={styles.live}>
          <span className={styles.liveDot} />3 suppliers · 1 owner
        </span>
      </div>

      <div
        className={styles.svgHost}
        aria-hidden="true"
        data-inview={inView}
        dangerouslySetInnerHTML={{ __html: CONCENTRATION_GRAPH_SVG }}
      />
    </div>
  );
};
